module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(!_vm.currentUser) ? _c('div', [_c('signInAndSignUp')], 1) : _vm._e(), _vm._v(" "), (_vm.currentUser) ? _c('div', {
    staticClass: "page"
  }, [_c('header', [_c('Topbar')], 1), _vm._v(" "), _c('main', [_c('ResumeEditor'), _vm._v(" "), _c('ResumePreview')], 1)]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.1@vue-loader/lib/template-compiler?{"id":"data-v-01656edd"}!./~/_vue-loader@12.2.1@vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 78
// module chunks = 1